<script setup lang="ts">
import type { IconSize, TpgClickEvent } from '@tpg/grammar-web';
import type { IconConstant } from '@tpg/grammar-web-icons';

import type { GrammarPrimaryButtonType } from './component-types';

export interface GrammarPrimaryButtonProps {
  type?: GrammarPrimaryButtonType;
  size?: 'small' | 'regular';
  label?: string;
  ariaLabel?: string;
  disabled?: boolean;
  iconTemplate?: IconConstant | '';
  iconPosition?: 'leading' | 'trailing' | 'top';
  iconOnlySize?: IconSize;
}

const props = withDefaults(defineProps<GrammarPrimaryButtonProps>(), {
  type: 'default',
  size: 'regular',
  label: '',
  ariaLabel: '',
  disabled: false,
  iconTemplate: '',
  iconPosition: 'leading',
  iconOnlySize: 'large',
});

const emit = defineEmits(['click']);

function onClick(event: TpgClickEvent) {
  emit('click', event);
}
</script>

<template>
  <tpg-primary-button v-bind="props" @tpg-click="onClick" />
</template>
